module.exports = __webpack_public_path__ + "img/footer-detail.0c3f213f.png";